import { memo } from "react";

const RootMain = ({ children, className = "" }) => (
	<main className={`root-main p-print-0 ${className}`} id="root-main">
		{children}
	</main>
);

export default memo(RootMain);
